var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9845 1.25002H8C7.58579 1.25002 7.25 1.58581 7.25 2.00002C7.25 2.41424 7.58579 2.75002 8 2.75002H13.0851L9.38515 21.25H4C3.58579 21.25 3.25 21.5858 3.25 22C3.25 22.4142 3.58579 22.75 4 22.75H9.98611C9.99593 22.7502 10.0057 22.7502 10.0155 22.75H16C16.4142 22.75 16.75 22.4142 16.75 22C16.75 21.5858 16.4142 21.25 16 21.25H10.9149L14.6149 2.75002H20C20.4142 2.75002 20.75 2.41424 20.75 2.00002C20.75 1.58581 20.4142 1.25002 20 1.25002H14.0139C14.0041 1.24983 13.9943 1.24983 13.9845 1.25002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.88cd24e4a1788022284bd829851bdbb0.svg";
export { ForwardRef as ReactComponent };